/**
 * 该文件用于创建Vuex中最为核心的store
 */

// 引入Vue
import Vue from "vue";

// 引入Vuex
import Vuex from 'vuex'

// 使用vuex
Vue.use(Vuex)

// 准备actions，用于响应组件中的动作
const  actions = {

}

// mutations，用于操作数据（state）  方法调用为commit
const  mutations = {
    PATH_URL(state,value){
        state.pathUrl = value
    },
    FROM_PATH(state,value){
        state.fromPath = value
    },
}

// state，用于存储数据
const  state = {
    pathUrl:{},
    fromPath:'',
    pathUrlList:[],
    activeTabs:'/home',
    headerColor:'#fcfcfc',
    asideColor:'#191a23',
    asideTextColor:'#ffffff',
    settingItem:{
        accordion:true,
        foldButton:true,
        defaultPack:true,
    },
    settingImg1:[
        {
            id:'bg1',
            src:'../assets/bg1.svg',
            status:true
        },
        {
            id:'bg2',
            src:'../assets/bg2.svg',
            status:false
        },
    ],
    settingImg2:[
        {
            id:'bg3',
            src:'../assets/bg3.svg',
            status:true
        },
        {
            id:'bg4',
            src:'../assets/bg4.svg',
            status:false
        },
        {
            id:'bg5',
            src:'../assets/bg5.svg',
            status:false
        },
    ]
}

// 准备getters，用于将state中的数据进行加工
const getters = {

}

// 创建并暴露store
export default new Vuex.Store({
    actions,
    mutations,
    state,
    getters
})